import { Image, Page, Text, View } from '@react-pdf/renderer';
import logo from 'assets/circles_logo_cv.png';
import circlesLogo from 'assets/circleslogo.png';
import { SkillsMemberModel } from 'generated-types/skills/member';

import { pageSize, SideGradientPanel, styles } from './styles';
import { ResumeProfileModel } from 'generated-types/skills/resume_profile';

const anonymizeText = (text: string, firstname: string, lastname: string): string => {
    const escaped = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return text
        .replace(new RegExp(`${escaped(firstname)}\\s+${escaped(lastname)}`, 'gi'), 'consultant')
        .replace(new RegExp(escaped(firstname), 'gi'), 'consultant')
        .replace(new RegExp(escaped(lastname), 'gi'), 'consultant');
};

export const IntroductionPage = ({
    member,
    externalPicture,
    selectedResumeProfile,
    anonymous,
}: {
    member: SkillsMemberModel;
    externalPicture?: string;
    selectedResumeProfile: ResumeProfileModel;
    anonymous?: boolean;
}) => {
    let profilePictureUri: string;
    if (anonymous) {
        profilePictureUri = circlesLogo;
    } else if (externalPicture) {
        profilePictureUri = externalPicture;
    } else if (member.image_url) {
        profilePictureUri = member.image_url.replace('=s96-c', '=s500-c');
    } else {
        profilePictureUri = ' ';
    }
    return (
        <Page size={pageSize} style={styles.introPage} wrap={false}>
            <View style={styles.logoContainer}>
                <Image style={styles.logo} src={logo} />
            </View>
            <SideGradientPanel />
            <View style={styles.profile}>
                <View style={styles.pictureContainer}>
                    <Image style={styles.userPicture} src={profilePictureUri} />
                </View>
                <View style={styles.informationContainer}>
                    {!anonymous && (
                        <Text style={styles.name} hyphenationCallback={word => [word]}>
                            {member.firstname} {member.lastname}
                        </Text>
                    )}
                    <Text style={styles.headline} hyphenationCallback={word => [word]}>
                        {anonymous && selectedResumeProfile?.headline
                            ? anonymizeText(selectedResumeProfile.headline, member.firstname, member.lastname)
                            : selectedResumeProfile?.headline}
                    </Text>
                    <View style={styles.aboutContainer}>
                        <Text style={styles.about} hyphenationCallback={word => [word]}>
                            {anonymous && selectedResumeProfile?.about
                                ? anonymizeText(selectedResumeProfile.about, member.firstname, member.lastname)
                                : selectedResumeProfile?.about}
                        </Text>
                    </View>
                </View>
            </View>
        </Page>
    );
};
